import React from "react";
import { Search } from "lucide-react";
import { useTranslation } from "react-i18next";

const FILTERS = [
  { key: "all",       testId: "filter-all" },
  { key: "alert",     testId: "filter-alert" },
  { key: "monitor",   testId: "filter-monitor" },
  { key: "analyzed",  testId: "filter-analyzed" },
  { key: "inactive",  testId: "filter-inactive" },
];

/**
 * Filter bar above the documents table.
 *
 * Mirrors the maquette: a search input on the left, then 5 status pills
 * (Tous, Alertes, À surveiller, Analysés, Non analysés). The pills are
 * QENVA-branded — the active pill switches to navy fill.
 */
export default function DocumentsFilterBar({ q, onQ, status, onStatus }) {
  const { t } = useTranslation("documents");
  return (
    <div
      data-testid="documents-filter-bar"
      className="flex flex-wrap items-center gap-3 px-5 py-4 border-b border-zinc-100"
    >
      <div className="relative flex-1 min-w-[200px] max-w-md">
        <Search
          size={15}
          strokeWidth={1.75}
          className="absolute left-3 top-1/2 -translate-y-1/2 text-zinc-400 pointer-events-none"
        />
        <input
          type="search"
          value={q || ""}
          onChange={(e) => onQ?.(e.target.value)}
          placeholder={t("filters.search_placeholder")}
          data-testid="documents-search-input"
          className="w-full pl-9 pr-3 h-9 rounded-full bg-qenva-off border border-zinc-200 text-[13px] text-qenva-navy placeholder:text-zinc-400 outline-none focus-visible:border-qenva-blue focus-visible:ring-2 focus-visible:ring-qenva-blue/15 transition"
        />
      </div>
      <div className="flex flex-wrap gap-2" role="tablist">
        {FILTERS.map((f) => {
          const isActive = status === f.key;
          return (
            <button
              key={f.key}
              type="button"
              role="tab"
              aria-selected={isActive}
              onClick={() => onStatus?.(f.key)}
              data-testid={f.testId}
              className={`h-9 px-4 rounded-full text-[12.5px] font-medium transition-all whitespace-nowrap border ${
                isActive
                  ? "bg-qenva-navy text-white border-qenva-navy shadow-[0_8px_18px_-12px_rgba(11,35,65,0.5)]"
                  : "bg-white text-zinc-700 border-zinc-200 hover:border-zinc-300 hover:text-qenva-navy"
              }`}
            >
              {t(`filters.${f.key}`)}
            </button>
          );
        })}
      </div>
    </div>
  );
}
